module.exports = __webpack_public_path__ + "img/skipdawg.bef74900.jpg";